import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const ReviewLeft = () => (
  <Wrapper>
    <FontAwesomeIcon icon={faCheckCircle} />
    <div>review left</div>
  </Wrapper>
);

export const Wrapper = styled.div`
  padding-right: 10px;
  font-size: 0.825em;
  text-align: center;
  color: ${({ theme }) => theme.colors.green};
  font-weight: 700;
  z-index: 1;
  background: #fff;
`;

export default ReviewLeft;
